import { debounceTime, skip, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Injector, Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent, ModalController, NavController, NavParams, PopoverController, } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Events } from '@omni/events';
import { IndTabsDataModel } from '@omni/models/ind-tabs-data-model';
import { IndPageTitleViewDataModel } from '@omni/models/indPageTitleDataModel';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '../../../classes/authentication/user.class';
import { RepServices } from '../../../data-services/rep/rep.services';
import { AccountOfflineService, EXCLUDED_ACCOUNT_GLANCE_CARD_ATTRIBUTES } from '../../../services/account/account.offline.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { DeviceService } from '../../../services/device/device.service';
import { FooterService, FooterViews } from '../../../services/footer/footer.service';
import { TrackingEventNames, TrackService } from '../../../services/logging/tracking.service';
import { NavigationService, PageName } from '../../../services/navigation/navigation.service';
import { ComponentViewMode, UIService } from './../../../services/ui/ui.service';
import { EventsService } from '@omni/services/events/events.service';
import { AssessmentTemplate, EntityOptions, TemplateType } from '@omni/classes/customer-assessment/assessment-template.class';
import { CustomerAssessment } from '@omni/classes/customer-assessment/customer-assessment.class';
import { CustomerAssessService } from '@omni/services/customer-assess/customer-assess.service';
import { ContactOfflineService } from '@omni/services/contact/contact.service';
import { NotificationService, ToastStyle } from '@omni/services/notification/notification.service';
import { GlanceCardViewDataModel, oneKeyGlanceViewData } from '@omni/models/glanceCardViewDataModel';
import { PersonalizeQuickGlanceViewDataModel } from '@omni/models/personalizeQuickGlanceViewModel';
import { getComponent } from '@omni/services/navigation/component-registry';
import { ControlDataType, DynamicForm, FormType } from '@omni/classes/dynamic-form/dynamic-form.class';
import { DefaultAccountDisplayForm } from '@omni/config/dynamic-forms/default-account-display';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { AccountDataService } from '@omni/data-services/accounts/account.data.service';
import { Account } from '@omni/classes/account/account.class';
import { NEW_ORDER_ACTION, newOrderButton, openNewOrder } from '../account-new-order';
import { ActivityService} from '@omni/services/activity/activity.service';
import { MeetingDataService, UpdateMeetingPayload } from '@omni/data-services/meeting/meeting.data.service';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { ActivityType } from '@omni/classes/activity/activity.class';
import { ContentMatchingService } from '@omni/services/content-matching/content-matching.service';
import { Contact } from '@omni/classes/contact/contact.class';
import { TerritoryManagementService } from '@omni/services/territory-management/territory-management.service';
import { ContactDataService } from '@omni/data-services/contact/contact.data.service';
import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { LocalizationService } from '@omni/services/localization/localization.service';
import { AdoptionLadderJourneyService } from '@omni/services/adoption-ladder-journey/adoption-ladder-journey.service';
import { RxSalesDataService } from '@omni/services/contact-spotlight/rxsalesdata.service';
import { isEmpty } from 'lodash-es';
import { QuickActionStripService } from '@omni/services/activity/quick-action-strip.service';
import { AccountQuickActionsService } from '@omni/services/activity/account-quick-actions.service';

const DEFAULT_FORM_LANGUAGE_CODE = "0000";
/**
 * Generated class for the AccountDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
// OnPush deferred — accountService.selected (object, 195 writes mutated in-place), 6+ subs without markForCheck, footerService.shouldApplyBottomMargin() not yet observable
@Component({
  selector: 'account-details',
  templateUrl: 'account-details.html',
  styleUrls:['account-details.scss']
})
export class AccountDetailsComponent implements OnInit {
  public isFollowupTaskEnabled = false;
  private isLayoverPushView = false;
  private layoverViewPushedFrom: string;
  public isNewActivityCreationEnabled = false;
  @Input() from: any;
  @Input() callbackEvent: any;
  tabsData: IndTabsDataModel[];
  public accountDetailSegment: string;

  /** Stable RecordRef for Nova's record-summary surface; recomputed by id+name. */
  private _novaRecordCacheKey: string | null = null;
  private _novaRecordCacheVal: { kind: 'account'; id: string; label: string } | null = null;
  get novaRecord(): { kind: 'account'; id: string; label: string } | null {
    const a: any = this.accountService?.selected ?? this.accountService?.selectedOKAccount;
    const id = a?.id;
    if (!id) return null;
    const label = (a.accountName || a.name || '').trim() || 'Account';
    const key = `${id}|${label}`;
    if (key === this._novaRecordCacheKey) return this._novaRecordCacheVal;
    this._novaRecordCacheKey = key;
    this._novaRecordCacheVal = { kind: 'account', id, label };
    return this._novaRecordCacheVal;
  }
  public pageTitle = '';
  public pageTitleControls = [];
  public okPageTitleControls = [];
  public okGlanceViewData: GlanceCardViewDataModel;
  public okGlanceBackButton: { id: string, icon: string } | undefined;
  public glanceBackButton: { id: string, icon: string } | undefined;
  private glanceCardTools = [];
  private titleBarTools = [];
  public glanceNameAction;
  // public isPopPageBtnEnabled:boolean = false;
  @ViewChild(IonContent) ionContent: IonContent;
  private scrollBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly scrollObservable: Observable<any> = this.scrollBehaviorSubject.asObservable().pipe(debounceTime(100));
  private refreshAccountNotesBehaviorSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public readonly refreshAccountNotesObservable: Observable<boolean> = this.refreshAccountNotesBehaviorSubject.asObservable();
  public hasCustomerAssessFA: boolean = false;
  public accountAssessmentTemplates: AssessmentTemplate[] = [];
  public accountAssessmentTemplatesTeamview: AssessmentTemplate[] = [];
  public assessRawData: CustomerAssessment;
  public customerAssessmentIsLoading: boolean = true;
  public customerAssessmentTeamviewIsLoading: boolean = true;
  public aiSummaryEnabled: boolean = false;

  private _isDisabledGoToAccountsToolBtn: boolean = false;
  public isGoToAccountBtnEnabled: boolean = false;
  private ngDestroy$ = new Subject<boolean>();
  private isTeamViewEnabled: boolean = false;
  public isFromChat: boolean = false;
  public isOpenedUnmappedAffiliationData : boolean = false;
  public accountGlanceViewData:GlanceCardViewDataModel;
  /** The strip the glance card renders, and whether anything is left behind the overflow. */
  public accountQuickActions: any[] = [];
  public hasQuickActionOverflow = false;
  public hasAccountJourney: boolean = false;
  public isGlobalSearch: boolean = false;
  public rawAccountSuggestionData: any[] = [];
  public rawAccountRxSalesData: any[] = [];
  public rawAccountRxSalesDataRealTimeFetched: any[] = [];

  constructor(
    public accountService: AccountOfflineService,
    private readonly accountDataService: AccountDataService,
    public device: DeviceService,
    public navCtrl: NavController,
    public uiService: UIService,
    public repService: RepServices,
    private readonly events: EventsService,
    private readonly navService: NavigationService,
    public trackingService: TrackService,
    private readonly authenticationService: AuthenticationService,
    public readonly footerService: FooterService,
    private readonly translate: TranslateService,
    private dynamicFormService: DynamicFormsService,
    private customerAssessService: CustomerAssessService,
    private contactService: ContactOfflineService,
    public notificationService: NotificationService,
    private navParams: NavParams,
    private readonly popoverCtrl: PopoverController,
    private readonly activityService: ActivityService,
    private readonly meetingService: MeetingDataService,
    private readonly contentMatchingService: ContentMatchingService,
    private territoryService: TerritoryManagementService,
    private contactDataService: ContactDataService,
    private modalCtrl: ModalController,
    private readonly injector: Injector,
    private featureActionService: FeatureActionsService,
    private localizationService: LocalizationService,
    private adoptionLadderJourneyService: AdoptionLadderJourneyService,
    private readonly rxSalesDataService: RxSalesDataService,
    private readonly quickActions: AccountQuickActionsService,
    private readonly quickActionStrip: QuickActionStripService,
  ) {
    this.events.subscribe('device:deviceIsOffline', (status) => {
      this.device.isOffline = true;
    });

    this.isFromChat = (this.navParams && this.navParams.data && this.navParams.data.viewData && this.navParams.data.viewData.from == 'openChat') || false;
    this.isOpenedUnmappedAffiliationData = this.dynamicFormService.openedUnmappedData;
    this.hasAccountJourney = this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_JOURNEY);
    // Must run before _initTabsData(): BU_ACCOUNT_GA_DEFAULTTAB's visibility check
    // reads this tab's `hide` at construction time, not ngOnInit.
    this.hasCustomerAssessFA = this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER_ASSESS);
    this._initTabsData();
  }

  private _initTabsData(){
    this.isGlobalSearch = this.navParams?.data && this.navParams.data?.link == 'globalSearch' || false;
    // Chat/global-search previews always land on 'info' — the configured
    // default (BU_ACCOUNT_GA_DEFAULTTAB) only applies to a genuine normal open.
    const isPreviewContext = this.isFromChat || this.isGlobalSearch;
    if(this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI,true)){
      this.tabsData = [
        {
          displayText: this.translate.instant('FEED'),
          value: 'feed',
          disable: this.isGlobalSearch
        },
        {
          displayText: this.translate.instant('OMNICHANNEL'),
          value: 'profile',
          disable: this.accountService.isOneKeySearching || this.isGlobalSearch,
        },
        {
          displayText: this.translate.instant('ASSESS'),
          value: "customer-assess",
          hide: !this.hasCustomerAssessFA,
          disable: this.isFromChat || this.isGlobalSearch
        },

        // {
        //   displayText: this.translate.instant('TIMELINE'),
        //   value: 'timeline',
        //   disable: this.accountService.isOneKeySearching,
        // },
        {
          displayText: this.translate.currentLang != "es" ? this.translate.instant('INFO') : this.translate.instant('INFORMATION'),
          value: 'info'
        },
        {
          displayText: this.translate.instant('JOURNEY'),
          value: 'journey',
          hide: !this.hasAccountJourney || this.isGlobalSearch,
          disable: false
        },
      ];
      this.uiService.accountDataSegment = this.accountDetailSegment = isPreviewContext ? 'info' : (this._resolveConfiguredDefaultTab() ?? 'feed');
    }else {
      this.tabsData = [
        {
           displayText: this.translate.currentLang != "es" ? this.translate.instant('INFO') : this.translate.instant('INFORMATION'),
           value: 'info'
        },
        {
          displayText: this.translate.instant('ASSESS'),
          value: "customer-assess",
          hide: !this.hasCustomerAssessFA,
          disable: this.isFromChat || this.isGlobalSearch
        },
        {
         displayText: this.translate.instant('PROFILE'),
         value: 'profile',
        disable: this.accountService.isOneKeySearching || this.isGlobalSearch,
        },
        {
          displayText: this.translate.instant('TIMELINE'),
          value: 'timeline',
          disable: this.accountService.isOneKeySearching || this.isGlobalSearch,
         },
        {
          displayText: this.translate.instant('JOURNEY'),
          value: 'journey',
          hide: !this.hasAccountJourney || this.isGlobalSearch,
          disable: false
        },
      ];
      this.uiService.accountDataSegment = this.accountDetailSegment = isPreviewContext ? 'info' : (this._resolveConfiguredDefaultTab() ?? 'info');
    }
  }

  private _resolveConfiguredDefaultTab(): string | null {
    const configuredTab = this.authenticationService.getIOConfigurationValue(IoConfigurationFeatureCodes.BU_ACCOUNT_GA_DEFAULTTAB);
    if (!configuredTab) return null;
    const tab = this.tabsData?.find(t => t.value === configuredTab.toLowerCase() && !t.hide && !t.disable);
    return tab ? tab.value : null;
  }


  async closepage() {
    if (this.from == 'NotificationDetails') {
      this.navService.popChildNavPageWithPageTracking();
      return;
    }
    if(this.customerAssessService.isAssessmentDirty && !(await this.customerAssessService.discardChagesForAssess())) return;
    this.accountService.selected = undefined;
    this.navService.setChildNavRoot(PageName.NothingSelectedView,PageName.NothingSelectedView,PageName.AccountPageComponent, {
        deviceString: this.device.deviceFlags.ios ? 'ios' : 'other',
      });
    this.navService.setChildNavRightPaneView(false);
    setTimeout(()=>{
      this.events.publish('accountListContentResize');
    },0);
  }

  ngOnInit() {
    this.quickActionStrip.loadPins('account').then(() => this._refreshQuickActions());
    // Crossing a breakpoint changes how many tiles fit, so the strip has to be rebuilt.
    this.quickActionStrip.capChanges()
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe(() => this._initGlanceCardData(true));
    this.device.isOfflineObservable
      .pipe(skip(1), takeUntil(this.ngDestroy$))
      .subscribe(() => this._refreshQuickActions());
    if (this.from) {
      this.isLayoverPushView = true;
      if (this.from === 'AccountManagementTool') {
        this.layoverViewPushedFrom = 'AccountManagementTool';
      } else if (this.from === 'AccountTool') {
        this.layoverViewPushedFrom = 'AccountTool';
      }
      else if(this.from == PageName.TerritoryManagementDetailsComponent){
        this.tabsData.find(a=> a.value == 'profile').disable = true;
        this.tabsData.find(a=> a.value == 'timeline').disable = true;
      }
    }
    if (this.uiService.accountDataSegment !== '') {
      this.accountDetailSegment = this.uiService.accountDataSegment;
    }

    this.isGlobalSearch = this.navParams?.data && this.navParams.data?.link == 'globalSearch' || false;
    if (this.isFromChat || this.isGlobalSearch) this.accountService.accountPageMode = ComponentViewMode.PREVIEW;
    this.isFollowupTaskEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY);
    this.isTeamViewEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.ASSESSMENTS_TEAM_VIEW);
    this.isNewActivityCreationEnabled = this.accountService.accessedAccountListFrom === PageName.GoAppActivitiesPageComponent;
    if (this.navParams && this.navParams.data && this.navParams.get('listMode') && (this.navParams.get('listMode') == ComponentViewMode.ADDNEW || this.navParams.get('listMode') == ComponentViewMode.SELECTION)) {
      this.isNewActivityCreationEnabled = false;
    }
    // if ((this.dynamicFormService.isOpenedAffiliatedAccountOnContact && this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent)
    // || (this.dynamicFormService.isOpenedAffiliatedAccountOnAccount && this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent)) {
    //   this.accountService.isEnableGoToAccountsTool = true;
    //   this.isPopPageBtnEnabled = true;
    // }

    // if(this.navService.getActiveChildNavViewPageName() === PageName.CallPlanCustDetailsComponent && this.navParams && this.navParams.data && this.navParams.get('accountListMode') == ComponentViewMode.READONLY) {
    //   this.isPopPageBtnEnabled = true;
    // }

    this.aiSummaryEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.ACCOUNT_AI_SUMMARY);
    if (this.hasAccountJourney && !this.isGlobalSearch) {
      this.initAccountJourneyData();
    }
    this.initPageTitle();
    this.initOKPageTitle();
    this._initGlanceCardData();
    this.initCustomerAssessData();

    this.dynamicFormService.affiliatedContacts = [];

    this.events.observe('refreshAccountDetailPageTitle').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.initPageTitle();
      this._initGlanceCardData();
    });

    this.events.observe('refershAccountDetailSegment').pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.accountDetailSegment = this.uiService.accountDataSegment;
      if (this.uiService.accountDataSegment != 'timeline') {
        this.accountService.isOpenedSurveyTimelineFromAccountProfile = false;
      }
    });

  }

  ionViewDidEnter(){
    if(this.isFromChat){
      this.footerService.initButtons("");
    } else if(this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent){
      this.refreshAccountNotesBehaviorSubject.next(true);
      this.footerService.initButtons(FooterViews.Accounts);
    }else if (this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent && this.isFromChat) {
      this.footerService.initButtons(FooterViews.Accounts);
    }else if(this.navService.getActiveChildNavViewPageName() === PageName.ActivitiesDetailsPaneComponent){
      this.footerService.initButtons(FooterViews.Activities);
    }else if(this.navService.getActiveChildNavViewPageName() === PageName.CaseManagementDetailComponent){
      this.footerService.initButtons(FooterViews.CUSTOMER_INQUIRY);
    }
  }

  ngAfterViewInit(){
    this.accountDetailSegment = this.uiService.accountDataSegment || this.tabsData[0].value;
  }

  ngOnDestroy() {
    if (this.accountService.accountPageMode === ComponentViewMode.PREVIEW) this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
    if (this.contactService.contactPageMode === ComponentViewMode.PREVIEW) this.contactService.contactPageMode = ComponentViewMode.LISTVIEW;
    this.dynamicFormService.isOpenedAffiliatedContactOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
    this.dynamicFormService.isOpenedAffiliatedContactOnContact = false;
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
  }

  initCustomerAssessData() {
    if (this.hasCustomerAssessFA) {
      this.accountAssessmentTemplates = this.customerAssessService.getTemplatesForEntity(TemplateType.ASSESSMENT, EntityOptions.ACCOUNT);
      if(this.isTeamViewEnabled) this.accountAssessmentTemplatesTeamview = this.customerAssessService.getTemplatesTeamviewForEntity(TemplateType.ASSESSMENT, EntityOptions.ACCOUNT);
      if (this.accountAssessmentTemplates.length == 1) {
        this.customerAssessService.fetchAccountAssessment(this.accountService.selected.id, this.accountAssessmentTemplates[0].indskr_assessmenttemplateid).then((data: CustomerAssessment) => {
          this.assessRawData = data;
          this.customerAssessmentIsLoading = false;
          this.customerAssessmentTeamviewIsLoading = false;
        });
      } else {
        this.customerAssessmentIsLoading = false;
        this.customerAssessmentTeamviewIsLoading = false;
      }
    }
  }

  public handlePlusButton(){
    this.navService.pushChildNavPageWithPageTracking(PageName.NewActivityComponent,PageName.NewActivityComponent,PageName.AccountPageComponent,{from:'AccountTool',account:this.accountService.selected});
  }

  public savedCustomerAssessment(data: CustomerAssessment) {
    this.assessRawData = data;
  }

  handleAffiliationExplorer(){
    this.navService.pushChildNavPageWithPageTracking(PageName.AffiliationExplorerComponent,PageName.AffiliationExplorerComponent,PageName.AccountPageComponent ,
      { from: 'AccountPageComponent',parent:this.accountService.selected,
      relatedFrom:this.accountService.linkEntityAccountFrom,
      relatedTo: this.accountService.linkEntityAccountTo,
      contactAccountAffiliation:this.accountService.linkedAccountContact,
      accountToBrand:this.accountService.brandAffiliationByAccountId
    });
  }

  async segmentChanged(slectedTab: string) {
    if (this.hasCustomerAssessFA) {
      if (this.uiService.accountDataSegment == "customer-assess" && this.customerAssessService.isAssessmentDirty && !(await this.customerAssessService.discardChagesForAssess())) {
        return;
      }
    }
    if (this.ionContent) {
    this.ionContent.scrollToTop();
    }
    this.uiService.accountDataSegment = this.accountDetailSegment = slectedTab;
    if (slectedTab == 'timeline') {
      this.trackingService.tracking('AccountTimeline', TrackingEventNames.ACCOUNTS);
    }
    if (slectedTab == 'info') {
      this.trackingService.tracking('AccountInfo', TrackingEventNames.ACCOUNTS);
    }
    if (slectedTab != 'timeline') {
      this.accountService.isOpenedSurveyTimelineFromAccountProfile = false;
    }
    if (slectedTab === 'journey') {
      this.footerService.initButtons(FooterViews.None);
    }
    this.initPageTitle();
  }

  isSplitView() {
    return (window.innerWidth > 620);
  }

  private _isPopPageBtnEnabled(): boolean {
    let isPopPageBtnEnabled: boolean = false;
    if ((this.dynamicFormService.isOpenedAffiliatedAccountOnContact && this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent)
    || (this.dynamicFormService.isOpenedAffiliatedAccountOnAccount && this.navService.getActiveChildNavViewPageName() === PageName.AccountDetailsComponent)) {
      this.accountService.isEnableGoToAccountsTool = true;
      isPopPageBtnEnabled = true;
    }else if(this.navService.getActiveChildNavViewPageName() === PageName.CallPlanCustDetailsComponent && this.navParams && this.navParams.data && this.navParams.get('accountListMode') == ComponentViewMode.READONLY) {
      isPopPageBtnEnabled = true;
    }
    return isPopPageBtnEnabled;
  }

  public isAccountAssessmentFormDirty(isDirty: boolean) {
    this.customerAssessService.isAssessmentDirty = isDirty;
  }

  poppage() {
    if (this.navService.getActiveChildNavViewPageName() === PageName.ContactDetailsComponent) {
      if (this.dynamicFormService.isOpenedAffiliatedAccountOnContact) {
        if (this.accountService.accountPrevPageMode === ComponentViewMode.ADDNEW || this.accountService.accountPrevPageMode === ComponentViewMode.SELECTION) {
          this.accountService.accountPageMode = this.accountService.accountPrevPageMode;
        } else {
          this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
        }
        this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
        this._isDisabledGoToAccountsToolBtn = false;
        this.dynamicFormService.openedUnmappedData = false;
        this.events.publish('refreshDisplayForm');
      }
      // this.uiService.activeView = 'contactDetails';
      this.accountService.selected = undefined;
      this.footerService.initButtons(FooterViews.Contacts);
      this.navService.popChildNavPageWithPageTracking();
    } else if (this.dynamicFormService.isOpenedAffiliatedAccountOnContact) {
      if (this.accountService.accountPrevPageMode === ComponentViewMode.ADDNEW || this.accountService.accountPrevPageMode === ComponentViewMode.SELECTION) {
        this.accountService.accountPageMode = this.accountService.accountPrevPageMode;
      } else {
        this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
      }
        this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
        this._isDisabledGoToAccountsToolBtn = false;
        this.dynamicFormService.openedUnmappedData = false;
        this.events.publish('refreshDisplayForm');
        this.navService.popChildNavPageWithPageTracking();
    } else if (this.dynamicFormService.isOpenedAffiliatedAccountOnAccount) {
      
      if (this.accountService.accountPrevPageMode === ComponentViewMode.ADDNEW || this.accountService.accountPrevPageMode === ComponentViewMode.SELECTION) {
        this.accountService.accountPageMode = this.accountService.accountPrevPageMode;
      } else {
        this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
      }
      if (this.accountService.prevSelected) this.accountService.selected = this.accountService.prevSelected;
      this.events.publish('highlightAccount', this.accountService.selected);
      this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = false;
      this._isDisabledGoToAccountsToolBtn = false;
      this.isOpenedUnmappedAffiliationData = this.dynamicFormService.openedUnmappedData = false;
      this.uiService.accountDataSegment = this.accountDetailSegment = 'info';
      this.navService.popChildNavPageWithPageTracking();
      this.events.publish('refreshDisplayForm');
    } else if (this.navService.getActiveChildNavViewPageName() === PageName.CallPlanCustDetailsComponent) {
      this.navService.popChildNavPageWithPageTracking();
    } else {
      this.navService.popWithPageTracking();
    }
  }

  private initPageTitle(): void {
    const isGlobalSearch: boolean = this.navParams?.data && this.navParams.data?.link == 'globalSearch' || false;
    let buttons = [];
    if(this.isFromChat) {
      buttons.push({
        id: 'close',
        icon: 'close-outline',
        isDisabled: false,
        align: "left"
      })
    }
    if (!this.isSplitView() || this._isPopPageBtnEnabled()) {
      buttons.push({
        id: 'close',
        icon: 'chevron-back-outline',
        isDisabled: false,
        align: 'left'
      });
    }
    if (this.accountDetailSegment !== 'customer-assess' && this.isNewActivityCreationEnabled && !isGlobalSearch) {
      const hideNewActivityCreation = (this.featureActionService.isShortCallLauncherEnabledInMobileDevice && this.authenticationService.hasFeatureAction(FeatureActionsMap.SHOR_CALL_LAUNCHER_DISABLE_APPOINTMENT_IN_NEW_ACTIVITY)) ?
      !(this.authenticationService.hasFeatureAction(FeatureActionsMap.STORE_CHECK) ||
      this.authenticationService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT) ||
      this.authenticationService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY) ||
      this.authenticationService.hasFeatureAction(FeatureActionsMap.PROCEDURE_LOG))
      : false;
      if (this.accountService.isAffiliationEnabled && !this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI,true)) {
        buttons.push({
          id: "affiliation-explorer",
          imgSrc: 'assets/imgs/affiliation-explorer.svg',
          name: this.translate.instant('AFFILIATION_EXPLORER'),
          isDisabled: !this.accountService.hasAffiliationsForExplorer(),
          align: "right"
        })
      }
      if (!hideNewActivityCreation) {
        buttons.push({
          id: 'pluse-icon',
          imgSrc: 'assets/imgs/ios_add_3x.svg',
          name: this.translate.instant('CREATE'),
          isDisabled: this.accountService.isOneKeySearching,
          align: 'right'
        });
      }
    }
    this.isGoToAccountBtnEnabled = this.accountDetailSegment != 'customer-assess'
                                                && (this.contactService.contactPageMode == ComponentViewMode.PREVIEW || this.accountService.accountPageMode == ComponentViewMode.PREVIEW)
                                                && (this.uiService.isAccountsFromToolDrawer || this.uiService.isContactsFromToolDrawer)
                                                && this._isPopPageBtnEnabled() && this.accountService.isEnableGoToAccountsTool
                                                && (this.dynamicFormService.isOpenedAffiliatedAccountOnContact || this.dynamicFormService.isOpenedAffiliatedAccountOnAccount)
                                                && !this.uiService.isForcedHideGoToToolBtn;
    if (this.isGoToAccountBtnEnabled || (this.from == 'NotificationDetails' && this.accountDetailSegment != 'customer-assess')) {
      buttons = [];
      buttons.push({
          id: 'close',
          icon: 'chevron-back-outline',
          isDisabled: false,
          align: 'left'
      });
      buttons.push({
        id: "goToAccountsTool",
        imgSrc: 'assets/imgs/glance-open-in-new.svg',
        name: this.translate.instant('OPEN'),
        isDisabled: this._isDisabledGoToAccountsToolBtn,
        align: "right"
      });
    }
    const isAssessTeamview: boolean = this.uiService.accountDataSegment =='customer-assess-teamview';
    if(isAssessTeamview) {
      buttons = [{
        id: "close-teamview",
        icon: "chevron-back-outline",
        isDisabled: false,
        align: "left"
      }];
    }
    if (this.from && this.from == PageName.TerritoryManagementDetailsComponent) {
      buttons = [];
      buttons.push({
          id: 'gotoTerritoryMgmtDetails',
          icon: 'chevron-back-outline',
          isDisabled: false,
          align: 'left'
      });
    }
    // Wherever the activity tiles are, however the account was reached (the home table records no
    // origin), less the views that are not the account's own: previews, selection and read-only lists
    // (Call Plan passes its mode as `accountListMode`), notifications.
    const listModes = [this.navParams?.data?.listMode, this.navParams?.data?.accountListMode];
    const canCreateOrder = this._isActionableAccount() && this.accountDetailSegment !== 'customer-assess'
      && ![ComponentViewMode.ADDNEW, ComponentViewMode.SELECTION, ComponentViewMode.READONLY].some(mode => listModes.includes(mode))
      && this.accountService.accountPageMode !== ComponentViewMode.PREVIEW && !this.isGoToAccountBtnEnabled
      && this.from !== 'NotificationDetails' && this.from !== PageName.TerritoryManagementDetailsComponent;
    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.NEW_ORDER_FLOW) && canCreateOrder && !isAssessTeamview) {
      buttons.push(newOrderButton(this.translate));
    }
    this.pageTitleControls = buttons;
    this.glanceBackButton = buttons.find(button => button.align === 'left');
    this.glanceNameAction = buttons.find(button => button.id === 'goToAccountsTool');
    this.titleBarTools = buttons.filter(button => button.align === 'right' && button.id !== 'pluse-icon' && button !== this.glanceNameAction);
    if (this.accountGlanceViewData) {
      this.accountGlanceViewData = { ...this.accountGlanceViewData, buttons: [...this.glanceCardTools, ...this.titleBarTools] };
    }
  }

  private initOKPageTitle(): void {
    let buttons = [];
    if(!this.isSplitView() || this._isPopPageBtnEnabled()) {
      buttons.push({
        id: 'close',
        icon: 'chevron-back-outline',
        isDisabled: false,
        align: 'left'
      });
    }
    const isAssessTeamview: boolean = this.uiService.accountDataSegment =='customer-assess-teamview';
    if(isAssessTeamview) {
      buttons = [{
        id: "close-teamview",
          icon: "chevron-back-outline",
          isDisabled: false,
          align: "left"
      }];
    }
    this.okPageTitleControls = buttons;
    this.okGlanceBackButton = buttons.find(button => button.align === 'left');
    const okAccount = this.accountService.selectedOKAccount;
    this.okGlanceViewData = okAccount ? oneKeyGlanceViewData(this.accountService.getAccountName(okAccount)) : undefined;
  }

  public onPageTitleControlClick(id: string) {
    switch (id) {
      case 'close':
        if (this.isFromChat) {
          this.modalCtrl.dismiss();
        } else if (this._isPopPageBtnEnabled()) {
          this.poppage();
        } else {
          this.closepage();
        }
        break;
      case 'close-teamview':
        this.uiService.accountDataSegment = 'customer-assess';
        this.initOKPageTitle();
        this.initPageTitle();
        break;
      case 'pluse-icon':
        this.handlePlusButton();
        break;
      case 'affiliation-explorer':
        this.handleAffiliationExplorer();
        break;
      case 'goToAccountsTool':
        this.handleGoToAccountsTool();
        break;
      case NEW_ORDER_ACTION:
        void openNewOrder(this.injector, this.accountService.selected);
        break;
        case 'gotoTerritoryMgmtDetails':
        this.handleGoToTerritoryMgmtDetails();
        break;
      default:
        break;
    }
  }

  onScroll(ev) {
    this.scrollBehaviorSubject.next(ev);
  }

  handleGoToAccountsTool() {
    this.accountService.isClickedGoToAccountsTool = true;
    if (!this.accountService.isNotInMyAccountList) {
      this.uiService.isAccountsFromToolDrawer = true;
      // this.navService.popWithPageTracking();
      if (this.from == 'NotificationDetails') this.navService.popChildNavPageWithPageTracking();
      // Already inside the Accounts tool - an account-to-account affiliation opens
      // as a preview in this same page rather than on a pushed one. Re-rooting
      // AccountPageComponent onto itself destroys the current instance, and its
      // ngOnDestroy nulls accountService.selected; the new page then opened the
      // details view with no account, which threw out of _initGlanceCardData and
      // left both panes blank. Promote the preview in place instead.
      if (this.navService.getCurrentMasterPageName() === PageName.AccountPageComponent) {
        this._openPreviewedAccountInAccountsTool();
        return;
      }
      this.navService.setRootWithTracking(PageName.AccountPageComponent, PageName.AccountPageComponent, { __source: 'menu', from: 'AccountTool', listMode: ComponentViewMode.LISTVIEW, openedToolFromAccountDetails: true }, PageName.AccountPageComponent);
      this.navService.setChildNavRightPaneView(true);
    } else if (this.accountService.errorMessageOpenAccountDetails) {
      this.accountService.isClickedGoToAccountsTool = false;
      this.notificationService.notify(this.accountService.errorMessageOpenAccountDetails, 'Account Details', 'top', ToastStyle.INFO);
      this._isDisabledGoToAccountsToolBtn = true;
      this.initPageTitle();
    }
  }

  /**
   * Turns the affiliated-account preview into the normal selection of the
   * Accounts tool we are already in, without re-rooting the page. Mirrors what
   * AccountListComponent.ngAfterViewInit() does when the tool is entered from
   * elsewhere: drop the preview flags, leave PREVIEW mode, highlight the row and
   * re-root the right pane on the details view.
   */
  private _openPreviewedAccountInAccountsTool() {
    const account = this.accountService.selected;
    this.accountService.isClickedGoToAccountsTool = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnAccount = false;
    this.dynamicFormService.isOpenedAffiliatedAccountOnContact = false;
    this.accountService.accountPageMode = ComponentViewMode.LISTVIEW;
    this.accountService.accessedAccountListFrom = PageName.AccountPageComponent;
    // Published after leaving PREVIEW: the list ignores the event while in it.
    if (account) this.events.publish('highlightAccount', account);
    this.navService.setChildNavRoot(PageName.AccountDetailsComponent, PageName.AccountDetailsComponent, PageName.AccountPageComponent, { from: 'AccountTool', listMode: ComponentViewMode.LISTVIEW });
    this.navService.setChildNavRightPaneView(true);
  }

  handleGoToTerritoryMgmtDetails() {
    this.navService.popChildNavPageWithPageTracking().then(() => {
      this.callbackEvent();
    });
    this.navService.setChildNavRightPaneView(true);
  }

  /**
   * A globally-searched account was never position-synced, so the local customer-address
   * store has no row for it and the glance card showed "No Location" despite the account
   * having addresses. They do arrive on the live detail fetch, under
   * globalSearchedDataLinkEntities. Mirrors ContactDetailsComponent's equivalent.
   */
  private _getGlobalSearchLocationText(): string {
    const linkEntities = this.accountService.selected?.raw?.['globalSearchedDataLinkEntities'];
    const addressKey = 'indskr_indskr_customeraddress_v2';
    const rows = linkEntities?.[DB_KEY_PREFIXES.ACCOUNT_LINKED_ENTITY + addressKey] ?? linkEntities?.[addressKey];
    if (!Array.isArray(rows) || !rows.length) return '';
    const primary = rows.find(r => r?.[`${addressKey}.indskr_isprimary`]) ?? rows[0];
    // Orgs configure the address subgrid with either the composite or the name column.
    return primary?.['indskr_address.indskr_composite']
      || primary?.['indskr_address.indskr_name']
      || primary?.[`${addressKey}.indskr_address@OData.Community.Display.V1.FormattedValue`]
      || '';
  }

  private async _initGlanceCardData(updateButtonsOnly: boolean = false) {
    // Everything below describes the selected account. Without one the first
    // dereference throws, and because this runs from ngOnInit that aborts the
    // whole details view, not just the glance card - a blank page instead of a
    // missing card. Bail quietly and let the caller that cleared the selection
    // be the thing that gets fixed.
    if (!this.accountService.selected) return;
    const isGlobalSearch: boolean = this.navParams?.data && this.navParams.data?.link == 'globalSearch' || false;

    if (this.authenticationService.hasFeatureAction(FeatureActionsMap.CUSTOMER360UI, true)) {
      let glanceCardButtons = [];
      let account = this.accountService.getAccountById(this.accountService.selected.id);
      const isReadOnlyView: boolean = this.isFromChat || this.isOpenedUnmappedAffiliationData || isGlobalSearch;
      
      // The activity tiles come from AccountQuickActionsService now; what is built here is
      // the tool tail that follows the divider.
      this._refreshQuickActions();
      // Only the Accounts list and sync completion set the flag; a contact's affiliated account arrives with neither.
      await this.accountService.affiliationControl();
      if (this.accountService.isAffiliationEnabled && !isReadOnlyView) {
        if (this.accountService.relationshipsLoadedForAccountId !== this.accountService.selected.id) {
          await this.accountService.getAccountRelationshipById(this.accountService.selected.id);
        }
        glanceCardButtons.push({
          id: "affiliation-explorer",
          imgSrc: 'assets/imgs/glance-affiliation-explorer.svg',
          name: this.translate.instant('AFFILIATION_EXPLORER'),
          isDisabled: !this.accountService.hasAffiliationsForExplorer(),
          align: "right"
        });
      }
      if (!isGlobalSearch) {
        glanceCardButtons.push({
          id: "personalize-quick-glance",
          imgSrc: 'assets/imgs/glance-personalize-settings.svg',
          name: 'Personalize Quick Glance',
          isDisabled: this.isFromChat || isGlobalSearch,
          align: "right"
        });
      }
      this.glanceCardTools = glanceCardButtons;
      if (updateButtonsOnly && this.accountGlanceViewData) {
        this.accountGlanceViewData = { ...this.accountGlanceViewData, buttons: [...this.glanceCardTools, ...this.titleBarTools] };
        return;
      }
      const values = await this.accountService._getQuickGlanceValues();
      if(!this.device.isOffline){
        this.accountDataService.getEntityImageStringForAccount(this.accountService.selected).then((entityImageString => {
          if(entityImageString){
            this.accountService.selected.entityImage = entityImageString;
            if(this.accountGlanceViewData){
              this.accountGlanceViewData.avatarURL = this.accountService.selected.entityImage
            }
          }
        }));
      }
      const address = await this.accountService.getPrimaryAddressOfAccount(this.accountService?.selected?.id);
      this.accountGlanceViewData = {
        name: this.accountService?.selected?.accountName,
        locationText: address ? address.compositeAdd : this._getGlobalSearchLocationText(),
        avatarURL: this.accountService.selected.entityImage,
        thirdText: (values && values.length && values[0]) ? values[0].value : '',
        fourthText: (values && values.length && values[1]) ? values[1].value : '',
        fifthText: (values && values.length && values[2]) ? values[2].value : '',
        sixthText: (values && values.length && values[3]) ? values[3].value : '',
        thirdTextLabel: (values && values.length && values[0]) ? values[0].label : '',
        fourthTextLabel: (values && values.length && values[1]) ? values[1].label : '',
        fifthTextLabel: (values && values.length && values[2]) ? values[2].label : '',
        sixthTextLabel: (values && values.length && values[3]) ? values[3].label : '',
        buttons: [...this.glanceCardTools, ...this.titleBarTools],
        enableExpand: false,
        isExpanded: true,
      };
    }
  }

  /** The strip, rebuilt: the cap changed, a pin moved, or the card is being drawn. */
  private _refreshQuickActions(): void {
    const types = this._isActionableAccount() ? this.quickActions.types() : [];
    ({ tiles: this.accountQuickActions, hasOverflow: this.hasQuickActionOverflow } = this.quickActionStrip.layout(types, 'account'));
  }

  /** The rep's own account, opened as itself: activities and orders may be started from it. */
  private _isActionableAccount(): boolean {
    const isGlobalSearch: boolean = (this.navParams?.data && this.navParams.data?.link == 'globalSearch') || false;
    return !!this.accountService.selected && !this.isFromChat && !this.isOpenedUnmappedAffiliationData && !isGlobalSearch
      && !!this.accountService.getAccountById(this.accountService.selected.id);
  }

  public openQuickActionOverflow(event: Event): Promise<void> {
    return this.quickActionStrip.openOverflow(event, this.quickActions.types(), 'account',
      () => this._refreshQuickActions());
  }

  public async onQuickGlanceControlClick(data){
    if(data.id){
      if (await this.quickActionStrip.runById(this.quickActions.types(), data.id, data.event)) return;
      switch(data.id) {
        case 'affiliation-explorer':
          this.handleAffiliationExplorer();
          break;
        case 'personalize-quick-glance':
          this._openPersonalizeQuickGlanceView();
          break;
        case 'goToAccountsTool':
          this.onPageTitleControlClick(data.id);
          break;
        case NEW_ORDER_ACTION:
          void openNewOrder(this.injector, this.accountService.selected, data.event);
          break;
        default:
          break;
      }
    }
  }

  private async _openPersonalizeQuickGlanceView(){
    let options = await this._getQuickGlanceOptions();
    let personalizeQuickGlanceView:PersonalizeQuickGlanceViewDataModel = {
      id: 'personalizeQuickGlance',
      pageSectionHeader: {
        id:'personalizeQuickGlanceTitleSectionHeader',
        title: this.translate.instant('PERSONALIZE_QUICK_GLANCE'),
        controls: []
      },
      infoText: this.translate.instant('SELECT_ANY_4_SECTION_TO_VIEW_ON_CARD'),
      data: options,
      callbackEvent:async (id:string, event:any, dataRef:any)=> await this._handlePersonalizeQuickGlanceSave(id,event,dataRef),
    }
    const modal = await this.modalCtrl.create({
      component: await getComponent(PageName.PersonalizedQuickGlanceViewComponent).resolve(),
      cssClass: 'filter-menu-right-modal',
      backdropDismiss: true,
      componentProps: { viewData: personalizeQuickGlanceView },
    });
    await modal.present();
  }

  private async _getQuickGlanceOptions(){
    let result:Array<{id:string,title:string,isChecked:boolean}> = [];
    let accountForm: DynamicForm = await this.dynamicFormService.getFormDefinitionForEntity("account", FormType.DISPLAYFORM);
    const alreadySavedOptions = await this.accountService.getQuickGlanceOptions();
    const langCode = (!accountForm) ? DEFAULT_FORM_LANGUAGE_CODE : this.localizationService.selectedLanguage.localeID;
    if (!accountForm) {
      accountForm = new DynamicForm(DefaultAccountDisplayForm['value'][0]);
    }
    accountForm.metadata.forEach((tab) => {
      if (tab && tab.controls && tab.controls.length > 0) {
        tab.controls.forEach(control => {
          if (this.dynamicFormService.checkIfControlShouldNotBeVisible(control) || control.forceHide || control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType || !control.dataType  || !control.isVisible || EXCLUDED_ACCOUNT_GLANCE_CARD_ATTRIBUTES.some(a=> a == control.attributeName)) {
          }else {
            let displayTitle:string = '';
            const dt = control.displayNames.find(value => value.languagecode == langCode);
            if (dt) {
              displayTitle = dt.languagecode == DEFAULT_FORM_LANGUAGE_CODE ? this.translate.instant(dt.description) : dt.description;
            } else {
              let en = control.displayNames.find(value => value.languagecode == "1033"); // default to english if no translation for the specific language;
              if (en) {
                displayTitle = en.description
              } else {
                //recheck the default form language code in the case of custom fields
                const defalutLang = control.displayNames.find(value => value.languagecode == '0000');
                if(defalutLang && defalutLang.description) {
                  displayTitle = this.translate.instant(defalutLang.description);
                } else {
                  displayTitle = '';
                }
              }
            }
            result.push({
              id: control.attributeName,
              title: displayTitle,
              isChecked: alreadySavedOptions.some(a=> a == control.attributeName),
            })
          }
        });
      }
    });
    return result;
  }

  private async _handlePersonalizeQuickGlanceSave(id,event,dataRef){
    if(dataRef && Array.isArray(dataRef)){
      const selectedAttributes = dataRef.filter(a=> a.isChecked)?.map(b=> b.id);
      await this.accountService.saveQuickGlanceOptions(selectedAttributes);
      this._initGlanceCardData();
    }
  }

  private async _updateContactsOfSelectedMeeting(contacts: Contact[]) {
    if (this.activityService.selectedActivity && this.activityService.selectedActivity.type == ActivityType.Appointment && !(this.activityService.selectedActivity as AppointmentActivity).isCompleted) {
      this.activityService.selectedActivity['contacts'] = [];
      contacts.forEach(contact => {
        this.contactService.moveContactToSelected(contact);
      });
      const isAutoSubjectEnabled = this.authenticationService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT);
      const isAcinoBaseUser = this.authenticationService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
      let activity = (this.activityService.selectedActivity as AppointmentActivity);
      let isSubjectUpdated = false;
      if (isAutoSubjectEnabled || isAcinoBaseUser) {
        let subject: string = this.translate.instant('MEETING');
        let subPrefix = ` - ${subject} - ${this.authenticationService.user.displayName}`;
        const selectedContacts = Array.isArray(activity.contacts)
          ? activity.contacts
          : [];
        if (isAcinoBaseUser) {
          subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')}`;
        }
        switch (selectedContacts.length) {
          case 0:
            break;
          case 1:
            subject = `${selectedContacts[0].fullName}${subPrefix}`;
            if (isAcinoBaseUser) {
              subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')} - ${selectedContacts[0].fullName}`;
            }
            break;
          default:
            if (selectedContacts.length > 1) {
              selectedContacts.sort((contactA, contactB): number => {
                let contactAFullName = (contactA.firstName.length > 0) ? contactA.firstName + " " + contactA.lastName : contactA.lastName;
                let contactBFullName = (contactB.firstName.length > 0) ? contactB.firstName + " " + contactB.lastName : contactB.lastName;
                if (contactAFullName.toLowerCase() > contactBFullName.toLowerCase()) return 1;
                if (contactAFullName.toLowerCase() < contactBFullName.toLowerCase()) return -1;

                return 0;
              });
              subject = `${selectedContacts[0].fullName} + ${selectedContacts.length - 1}${subPrefix}`;
              if (isAcinoBaseUser) {
                subject = `${activity.activityTypeName ? activity.activityTypeName + ' ' : ''}${this.translate.instant('VISIT')} - ${selectedContacts[0].fullName}`;
              }
            }
        }
        if (this.activityService.selectedActivity.subject !== subject) {
          this.activityService.updateSelectedActivityProps({ subject });
          isSubjectUpdated = true;
        }

      }

      if (this.activityService.selectedActivity.location !== "LiveMeet") {
        if (!this.authenticationService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) &&  (this.authenticationService.user.buConfigs && !this.authenticationService.user.buConfigs['indskr_populateaccountaddress'])) {
          await this.contactService.setLocationField(contacts);
        }
      }

      if (!this.device.isOffline && !this.activityService.hasOfflineMeetingData(this.activityService.selectedActivity.ID)) {
        await this.meetingService.addContactsToMeeting(this.activityService.selectedActivity, true);
        this.events.publish('contentmatching:refresh');
        if (isSubjectUpdated) {
          const payload = new UpdateMeetingPayload(
            this.activityService.selectedActivity.subject,
            this.activityService.selectedActivity.location,
            this.activityService.selectedActivity.scheduledStart,
            this.activityService.selectedActivity.scheduledEnd
          );
          try {
            await this.meetingService.updateMeeting((this.activityService.selectedActivity as AppointmentActivity), payload);
          } catch (error) {
            console.error('AccountListComponent: _updateContactsOfSelectedMeeting: ', error);
            await this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity), false, true);
          }
        }
      } else {
        await this.activityService.upsertMeetingsOfflineData((this.activityService.selectedActivity as AppointmentActivity));
      }

      // Fix: the contact attached here (e.g. auto-populated affiliated contact when a meeting
      // is created starting from this account) was never folded into the secondary-info
      // subject, so the server kept whatever subject was computed before this contact existed
      // on the meeting. Mirrors the same fix already applied in new-activity.ts.
      await this.meetingService.recomputeSecInfoSubjectAfterAttach(this.activityService.selectedActivity as AppointmentActivity);
    }
  }
  async getTargetContactIds() {
    if(this.device.isOffline)
      return;


    await this.uiService.displayLoader();
    let currentCustomerListPeriodId = this.territoryService.currentListPeriod ? this.territoryService.currentListPeriod.indskr_customerlistperiodid : '';
    let contactsBasedOnPositionId = await this.contactDataService.getTargetContactsBasedOnCurrentCustomerListPeriod(this.authenticationService.user.positionID, currentCustomerListPeriodId);

    if (!isEmpty(contactsBasedOnPositionId)) {
      contactsBasedOnPositionId = contactsBasedOnPositionId.map((contact)=> {
        contact['ID'] = contact['contactid'];
        return contact;
      });

      this.dynamicFormService.targetContactIds = contactsBasedOnPositionId;
    }

    await this.uiService.dismissLoader();
  }

  private async initAccountJourneyData() {
    if (!this.hasAccountJourney || this.isGlobalSearch || this.accountService.isOneKeySearching) {
      return;
    }
    const accountId = this.accountService.selected?.id;

    if (accountId) {
      // subscribe to local DB data for fallback
      this.rxSalesDataService.directSalesData$.pipe(takeUntil(this.ngDestroy$)).subscribe(data => {
        if (Array.isArray(data) && data.length > 0) {
          const filteredData = data.filter(item => item?.account?.id === accountId);
          this.rawAccountRxSalesData = filteredData;
        }
      });

      let tasks = [];
      tasks.push(this.adoptionLadderJourneyService.fetchAccountJourneySuggestionData(accountId));
      tasks.push(this.adoptionLadderJourneyService.fetchAccountRxSalesData(accountId));

      const results = await Promise.all(tasks);
      if (results && results.length > 0) {
        if (results[0]) {
          this.rawAccountSuggestionData = results[0];
        }
        if (results[1]) {
          this.rawAccountRxSalesDataRealTimeFetched = results[1];
        }
      }
    }
  }
}
